import moment from 'moment'
import React from 'react'
import { Link, NavLink } from 'react-router-dom'

const Notifications = ({ data, notificationsMenuOpen, handleNotificationsMenuClick, makeRead }) => (
  <li className={notificationsMenuOpen ? 'dropdown open' : 'dropdown'}>
    <NavLink
      className='dropdown-toggle count-info'
      data-toggle='dropdown'
      to='#'
      onClick={() => handleNotificationsMenuClick(notificationsMenuOpen)}
    >
      <i className='fa fa-bell' />
      <span className='label label-primary'>{data.length === 0 ? '' : data.length}</span>
    </NavLink>

    <ul className='dropdown-menu dropdown-alerts animated fadeIn'>
      {data.slice(0, 3).map((item, index) => (
        <React.Fragment key={index}>
          <li>
            <NavLink to='#' onClick={() => makeRead(item)}>
              <div style={{ display: 'flex', flexFlow: 'column' }}>
                <span>
                  <i className='fa fa-envelope fa-fw' style={{ marginRight: '0.25rem' }} />
                  <span>{item.message.subject}</span>
                </span>

                <span className='pull-right text-muted small' style={{ textAlign: 'right' }}>
                  {moment(item.message.created).fromNow()}
                </span>
              </div>
            </NavLink>
          </li>
          <li className='divider' />
        </React.Fragment>
      ))}
      <li>
        <div className='text-center link-block'>
          <Link to='/notifications' onClick={() => handleNotificationsMenuClick(true)}>
            <strong>See All Notifications</strong>
            <i className='fa fa-angle-right' />
          </Link>
        </div>
      </li>
    </ul>
  </li>
)

export default Notifications
